 export enum DsnModeEnvoi {
EnvoiFichierTest = 0,
EnvoiFichierReel = 1,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/DsnModeEnvoi.ts